import { valueToEnumOrNull } from 'common/EnumUtils';
import { BrowseByTagsType, ClientEvents } from 'common/events/ClientEvents';
import { QueryParams } from 'common/urls/QueryParams';
import React, { useCallback } from 'react';
import { BrowseFilter, DishFirstSegmentFilter } from 'src/gqlReactTypings.generated.d';
import { QueryParamsUpdates, QueryParamsUpdateType } from 'src/pages/consumer/explore/useExploreUrl';
import { useTracker } from 'src/shared/hooks/useTracker';
import { match } from 'ts-pattern';
import { DietaryTags } from 'web-common/src/shared/Enums';
import { Segment } from './Segment';
import { Category } from './types';

interface CategoryProps {
  updateQueryParams: (updates: QueryParamsUpdates<DishFirstSegmentFilter>, updateType?: QueryParamsUpdateType) => void;
  cuisineCategories: Category[];
}

export const CategoryTop: React.FC<CategoryProps> = (props) => {
  const { updateQueryParams, cuisineCategories } = props;
  const tracker = useTracker();

  const onClick = useCallback(
    (value: string, position: number, tagType: BrowseByTagsType) => {
      match(tagType)
        .with(BrowseByTagsType.CUISINE, () => {
          const filters = {
            [QueryParams.CUISINE_FILTER]: [value],
            [QueryParams.BROWSE_FILTER]: BrowseFilter.Cuisine,
          };
          updateQueryParams(filters, 'pushIn');
          tracker.track(ClientEvents.BROWSE_BY_TAGS_CLICK, { tag: value, type: BrowseByTagsType.CUISINE, position });
        })
        .with(BrowseByTagsType.DIETARY_PREFERENCE, () => {
          const tag = valueToEnumOrNull(DietaryTags, value);
          if (!tag) return;

          const filters = {
            [QueryParams.DIETARY_FILTER]: [tag],
          };
          updateQueryParams(filters, 'pushIn');
          tracker.track(ClientEvents.BROWSE_BY_TAGS_CLICK, {
            tag: value,
            type: BrowseByTagsType.DIETARY_PREFERENCE,
            position,
          });
        })
        .otherwise(() => null);
    },
    [updateQueryParams, tracker]
  );

  return (
    <div className='bg-rice pb-4 pt-6 md:pb-0'>
      <Segment title='Top categories' categories={cuisineCategories} onClick={onClick} />
    </div>
  );
};
